import { createFileRoute } from '@tanstack/react-router';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';
import { NotificationsSettingsPage } from 'src/modules/settings/components/pages/notifications-settings.page';

export const Route = createFileRoute('/settings/notifications')({
  component: NotificationsSettingsPage,
  validateSearch: (search) => settingsSearchSchema.parse(search),
});
